'use client'

import type { PropsWithChildren } from 'react'

import { Toast } from '@moment/design-system-ui/toast'

export function ToastProvider({ children }: PropsWithChildren) {
  return <Toast>{children}</Toast>
}
